// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spot-pnl-page .spot-pnl-top-cards .spot-pnl-metric-card:first-child .spot-pnl-balance-main {
  font-size: 22px;
  font-weight: 600;
  margin-top: 4px;
  color: #eaecef;
}

body.light_theme .spot-pnl-page .spot-pnl-top-cards .spot-pnl-metric-card:first-child .spot-pnl-balance-main {
  color: #1e2329;
}

.spot-pnl-page .spot-pnl-balance-sub {
  font-size: 13px;
  color: #cfcfcf;
  margin-top: 4px;
}

body.light_theme .spot-pnl-page .spot-pnl-balance-sub {
  color: #707a8a;
}

.spot-pnl-page .spot-pnl-fallback-note {
  font-size: 13px;
}

.spot-pnl-page .spot-pnl-charts-grid {
  margin-top: 8px;
}

.spot-pnl-page .spot-pnl-daily-chart__wrap {
  height: 200px;
  max-height: 200px;
  overflow: hidden;
}

.spot-pnl-page .spot-pnl-daily-chart__svg {
  width: 100%;
  height: 200px;
  max-height: 200px;
}

.spot-pnl-page .options-pnl-chart__wrap:not(.spot-pnl-daily-chart__wrap) .options-pnl-chart__svg {
  max-height: 220px;
}

.spot-pnl-chart-empty {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 13px;
  color: #707a8a;
  padding: 16px;
}

.spot-pnl-chart-empty--center {
  min-height: 220px;
}

.spot-pnl-allocation {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  min-height: 200px;
}

.spot-pnl-allocation__svg {
  width: 160px;
  height: 160px;
  flex-shrink: 0;
}

.spot-pnl-allocation__legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-width: 140px;
}

.spot-pnl-allocation__legend-item {
  display: grid;
  grid-template-columns: 12px 1fr auto;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  color: #707a8a;
}

.spot-pnl-allocation__legend-item i {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.spot-pnl-footnote {
  font-size: 12px;
  color: #707a8a;
  line-height: 1.5;
}

.funding-account__spot-pnl .spot-pnl-analysis-link {
  font-size: 12px;
  font-weight: 500;
  color: #d1aa67;
  text-decoration: none;
}

.funding-account__spot-pnl .spot-pnl-analysis-link:hover {
  text-decoration: underline;
}

@media (max-width: 991px) {
  .spot-pnl-allocation {
    flex-direction: column;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/WalletPage/spotPnlAnalysis.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".spot-pnl-page .spot-pnl-top-cards .spot-pnl-metric-card:first-child .spot-pnl-balance-main {\n  font-size: 22px;\n  font-weight: 600;\n  margin-top: 4px;\n  color: #eaecef;\n}\n\nbody.light_theme .spot-pnl-page .spot-pnl-top-cards .spot-pnl-metric-card:first-child .spot-pnl-balance-main {\n  color: #1e2329;\n}\n\n.spot-pnl-page .spot-pnl-balance-sub {\n  font-size: 13px;\n  color: #cfcfcf;\n  margin-top: 4px;\n}\n\nbody.light_theme .spot-pnl-page .spot-pnl-balance-sub {\n  color: #707a8a;\n}\n\n.spot-pnl-page .spot-pnl-fallback-note {\n  font-size: 13px;\n}\n\n.spot-pnl-page .spot-pnl-charts-grid {\n  margin-top: 8px;\n}\n\n.spot-pnl-page .spot-pnl-daily-chart__wrap {\n  height: 200px;\n  max-height: 200px;\n  overflow: hidden;\n}\n\n.spot-pnl-page .spot-pnl-daily-chart__svg {\n  width: 100%;\n  height: 200px;\n  max-height: 200px;\n}\n\n.spot-pnl-page .options-pnl-chart__wrap:not(.spot-pnl-daily-chart__wrap) .options-pnl-chart__svg {\n  max-height: 220px;\n}\n\n.spot-pnl-chart-empty {\n  min-height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 13px;\n  color: #707a8a;\n  padding: 16px;\n}\n\n.spot-pnl-chart-empty--center {\n  min-height: 220px;\n}\n\n.spot-pnl-allocation {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  min-height: 200px;\n}\n\n.spot-pnl-allocation__svg {\n  width: 160px;\n  height: 160px;\n  flex-shrink: 0;\n}\n\n.spot-pnl-allocation__legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 140px;\n}\n\n.spot-pnl-allocation__legend-item {\n  display: grid;\n  grid-template-columns: 12px 1fr auto;\n  gap: 8px;\n  align-items: center;\n  font-size: 13px;\n  color: #707a8a;\n}\n\n.spot-pnl-allocation__legend-item i {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.spot-pnl-footnote {\n  font-size: 12px;\n  color: #707a8a;\n  line-height: 1.5;\n}\n\n.funding-account__spot-pnl .spot-pnl-analysis-link {\n  font-size: 12px;\n  font-weight: 500;\n  color: #d1aa67;\n  text-decoration: none;\n}\n\n.funding-account__spot-pnl .spot-pnl-analysis-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 991px) {\n  .spot-pnl-allocation {\n    flex-direction: column;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
